module.exports = __webpack_public_path__ + "static/media/rsz_harmony.d3f4b4c8.webp";